import { render } from "./Godfather.vue?vue&type=template&id=7df68a90&scoped=true"
import script from "./Godfather.vue?vue&type=script&lang=js"
export * from "./Godfather.vue?vue&type=script&lang=js"

import "./Godfather.vue?vue&type=style&index=0&id=7df68a90&lang=scss&scoped=true"
import "./Godfather.vue?vue&type=style&index=1&id=7df68a90&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df68a90"]])

export default __exports__